<div class="error-page">
  <div class="error-card">
    <div class="error-header">
      <div class="error-icon">
        <svg-icon src="assets/icons/triangle-with-exclamation-mark.svg" [svgStyle]="{ 'width.px': 22, 'height.px': 22 }"></svg-icon>
      </div>
      <div class="error-heading">
        <div class="error-tag">Something went wrong</div>
        <h1 class="error-title">An unexpected error occurred</h1>
        <p class="error-subtitle">GAINS encountered a problem and couldn't complete your request. Our team has been notified automatically.</p>
      </div>
    </div>

    <hr class="error-divider" />

    <div class="error-detail-box">
      <div class="error-detail-label">What happened</div>
      <div class="error-detail-msg">The server couldn't complete your request. This is usually temporary — please try again in a moment.</div>
    </div>

    <div class="error-meta-row">
      <div class="error-meta-col">
        <div class="error-meta-label">Timestamp</div>
        <div class="error-meta-val">{{ timestamp | date: 'yyyy-MM-dd HH:mm' : 'UTC' }} UTC</div>
      </div>
    </div>

    <div class="error-actions">
      <button nz-button nzType="primary" nzShape="round" (click)="goBack()">
        <svg-icon src="assets/icons/arrow-left.svg" class="btn-icon btn-icon--light" aria-hidden="true"></svg-icon>
        Go back
      </button>
      <button nz-button nzType="default" nzShape="round" (click)="tryAgain()">
        <svg-icon src="assets/icons/arrow-rotate-anticlockwise.svg" class="btn-icon" aria-hidden="true"></svg-icon>
        Try again
      </button>
    </div>
  </div>
</div>
